import React from "react";

/**
 * @component MessageAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <MessageAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const MessageAddIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      data-testid="MessageAddIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M11 4v2H6v11.26L10.39 15H18v-2h2v2a2 2 0 01-2 2H9.995L4 21V6a2 2 0 012-2h5zm7-1v3h3v2h-3v3h-2V8h-3V6h3V3h2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
MessageAddIcon.displayName = "MessageAddIcon";
export default MessageAddIcon;
